import Repository from "@shared/services/api/abstracts/Repository";
import { PublicCharitySerializer } from "../types/charity";

export default class PublicCharityRepository extends Repository<PublicCharitySerializer> {
  public readonly repositoryName = "PublicCharityRepository";

  public readonly endpoint = "api/public/charity/{causeId}";
}
